interface TimeParams {
  start?: number;
  end?: number;
}

/**
 * Parse time parameters from a video URL.
 * Supports formats:
 * - ?t=start,end or ?t=start
 * - ?start=X&end=Y
 */
export const parseTimeParams = (url: string): TimeParams => {
  try {
    // Use base URL for relative URLs
    const urlObj = new URL(url, 'https://example.com');
    const params = urlObj.searchParams;

    // Check for 't' parameter (format: t=start,end or t=start)
    const tParam = params.get('t');
    if (tParam) {
      const timeParts = tParam.split(',').map((t) => parseFloat(t));

      return {
        start: !isNaN(timeParts[0]) ? timeParts[0] : undefined,
        end: !isNaN(timeParts[1]) ? timeParts[1] : undefined,
      };
    }

    // Check for separate start/end parameters
    const startParam = params.get('start');
    const endParam = params.get('end');
    const startVal = startParam ? parseFloat(startParam) : NaN;
    const endVal = endParam ? parseFloat(endParam) : NaN;

    return {
      start: !isNaN(startVal) ? startVal : undefined,
      end: !isNaN(endVal) ? endVal : undefined,
    };
  } catch {
    // If URL parsing fails, return empty params
    return {};
  }
};
